import {
  callApiCapNhatThuTu,
  callApiLayDanhSachChucVu,
  callApiLayDanhSachChucVuPaging,
  callApiSuaChucVu,
  callApiTaoChucVu,
  callApiXoaChucVu
} from "@/api/chuc-vu";
import {
  SUA_CHUC_VU_THANH_CONG,
  THEM_MOI_CHUC_VU_THANH_CONG,
  XOA_CHUC_VU_THANH_CONG
} from "@/constants/message";
import { showMsgOk, showMsgError } from "@/utils/commonUtils";

const layDanhSachChucVu = async ({ commit }, payload) => {
  const response = await callApiLayDanhSachChucVu(payload);
  if (response && response.data.succeeded) {
    commit("LAY_DANH_SACH_CHUC_VU_THANH_CONG", response.data.data);
  }
};

const layDanhSachChucVuPaging = (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiLayDanhSachChucVuPaging(payload)
      .then((response) => {
        context.commit("LAY_DANH_SACH_CHUC_VU_PHAN_TRANG", response.data.data);
        resolve(response)
      })
      .catch((error) => {
        reject(error);
      });
  });
};



const themChucVu = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    return callApiTaoChucVu(payload.data).then((res) => {
      resolve(res);
      showMsgOk(THEM_MOI_CHUC_VU_THANH_CONG);
      commit("THEM_MOI_CHUC_VU_THANH_CONG", response.data.data);
      payload.onSuccess();
    }).catch((err) => {
      reject(err.response)
    })
  })
};

const suaChucVu = async ({ commit }, payload) => {
  return new Promise((resolve, reject) => {
    return callApiSuaChucVu(payload.data).then((res) => {
      resolve(res);
      showMsgOk(SUA_CHUC_VU_THANH_CONG);
      commit("SUA_CHUC_VU_THANH_CONG", response.data.data);
      payload.onSuccess();
    }).catch((err) => {
      reject(err.response)
    })
  })
};

// eslint-disable-next-line no-empty-pattern
const xoaChucVu = async (context, payload) => {
  return new Promise((resolve, reject) => {
    callApiXoaChucVu(payload.data).then((res) => {
      showMsgOk(XOA_CHUC_VU_THANH_CONG);
      payload.onSuccess();
    }).catch((err) => {
      showMsgError(err.response.data.message);
    })
  });
};



// eslint-disable-next-line no-empty-pattern
const capNhatThuTu = async (context, payload) => {
  const response = await callApiCapNhatThuTu(payload.data);
  if (response && response.data.succeeded) {
    // payload.onSuccess();
  }
};

export default {
  layDanhSachChucVu,
  themChucVu,
  suaChucVu,
  xoaChucVu,
  capNhatThuTu,
  layDanhSachChucVuPaging
};
